/**
 * A change this context refused because it breaks one of its rules, as opposed to a failure it did
 * not expect. The backend context throws its own of the same name.
 */
// eslint-disable-next-line import/prefer-default-export
export class TenancyRuleViolation extends Error {
  constructor(message) {
    super(message);
    this.name = 'TenancyRuleViolation';
  }
}
